<!--
Author: TangChen
Date: 2018-09-06
Desc: 设置页面底部，为公共组件
 -->
<template>
    <div class="comp-fund-list comp">
        <el-row v-if="fundInfo.length <= 0" class="no-funds">
            <el-col :span="12" :offset="8">
                <span class="no-funds-img" />
                <div class="no-funds-box">
                    <p>{{ noFundMsg }}</p>
                </div>
            </el-col>
        </el-row>
        <el-table v-if="fundInfo.length > 0" :data="fundAll" style="width: 100%" :show-header="false">
            <el-table-column label="基金信息" :width="'960'">
                <template slot-scope="scope">
                    <el-row class="fund-list">
                        <el-col :span="24" class="fund-tit">
                            <span v-for="fund in recommendFund" :key="fund.tagids">
                                <span
                                    v-if="scope.row.tagids.indexOf(fund.tagid)>-1"
                                    class="type-index"
                                    :style="{'background-color':fund.tagcolor}"
                                >{{ fund.tagname }}</span>
                            </span>
                            <span style="cursor: pointer;" v-on:click="gotoDetail(scope.row)">
                                {{ scope.row.fundname+'('+scope.row.fundcode+')' }}
                                <i
                                    class="risk"
                                    :class="$util.riskCla(scope.row.risklevel)"
                                >{{ $cache.getDict('110143',scope.row.risklevel)+'风险' }}</i>
                                <i v-if="scope.row.businessflagext.indexOf('Y3') > -1" class="risk" style="color: #eba100; border-color: #eba100;">浮动管理费</i>
                            </span>
                        </el-col>
                        <el-col v-if="scope.row.reason" :span="24" class="spe-intro">
                            <p>{{ scope.row.reason }}</p>
                        </el-col>
                        <el-col :span="5">
                            <span
                                class="big"
                                :class="scope.row.allud>0?'add':(scope.row.allud<0?'reduce':'')"
                            >{{ $util.fmtNum(scope.row.allud) }}%</span>
                            <p>成立以来</p>
                        </el-col>
                        <el-col :span="5">
                            <span
                                :class="scope.row.yearud>0?'add':(scope.row.yearud<0?'reduce':'')"
                            >{{ $util.fmtNum(scope.row.yearud) }}%</span>
                            <p>今年以来</p>
                        </el-col>
                        <el-col v-if="scope.row.fundtype!=='2'" :span="5">
                            <span>{{ $util.fmtNum(scope.row.nav,4) }}</span>
                            <p>{{ '单位净值('+$util.fmtDate(scope.row.navdate)+')' }}</p>
                        </el-col>
                        <el-col v-else :span="5">
                            <span>{{ $util.fmtNum(scope.row.growthrate,4) }}%</span>
                            <p>七日年化</p>
                        </el-col>
                        <el-col v-if="scope.row.fundtype!=='2'" :span="5">
                            <span>{{ $util.fmtNum(scope.row.totalnav,4) }}</span>
                            <p>累计净值(元)</p>
                        </el-col>
                        <el-col v-else :span="5">
                            <span>{{ $util.fmtNum(scope.row.fundincomeunit,4) }}</span>
                            <p>万份收益(元)</p>
                        </el-col>
                        <el-col :span="4">
                            <span>{{ $util.fmtNum(fundGrowQry?scope.row[growData[fundGrowQry]]:scope.row.dayud) }}%</span>
                            <p>{{ fundGrowQry ? growArea[fundGrowQry] : "日涨跌幅" }}</p>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
            <!-- v-if="false"控制：暂时禁用交易功能，汇款支付上线再放开 -->
            <el-table-column v-if="$util.getConfig().hideFunc" label="基金操作" prop="fundcode" align="center" min-width="198px">
                <template slot-scope="scope">
                    <el-tooltip
                        v-if="scope.row.isBuy"
                        class="item"
                        effect="info"
                        :content="scope.row.isBuy + ',不能购买'"
                        placement="left"
                    >
                        <el-button v-show="url!=='glist'" type="lock" size="small">
                            购买
                        </el-button>
                    </el-tooltip>
                    <el-button
                        v-else
                        v-show="url!=='glist'"
                        type="yellow"
                        size="small"
                        v-on:click="callbackFn('20,22',scope.row.fundcode)"
                    >
                        {{ scope.row.isBuy===''?'购买':'认购' }}
                    </el-button>
                    <!--<el-tooltip-->
                    <!--v-if="scope.row.isCurrency"-->
                    <!--class="item"-->
                    <!--effect="info"-->
                    <!--:content="scope.row.isCurrency + ',不能购买'"-->
                    <!--placement="left"-->
                    <!--&gt;-->
                    <!--<el-button type="lock" size="small" :class="{'alone-btn':url==='glist'}">-->
                    <!--定投-->
                    <!--</el-button>-->
                    <!--</el-tooltip>-->
                    <!--<el-button-->
                    <!--v-else-->
                    <!--type="blue"-->
                    <!--size="small"-->
                    <!--:class="{'alone-btn':url==='glist'}"-->
                    <!--v-on:click="callbackFn('59',scope.row.fundcode)"-->
                    <!--&gt;-->
                    <!--定投-->
                    <!--</el-button>-->
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="Number(allPage) !== 0" class="page-box">
            <el-pagination
                background
                :page-sizes="pageSizes"
                :page-size="Number(pageSize)"
                :current-page.sync="curPage"
                :layout="pageLayout"
                :total="Number(allPage)"
                v-on:current-change="dataReset"
                v-on:size-change="sizeReset"
            >
                <el-button type="primary" plain v-on:click="showAll">
                    {{ !isShowAll ? "显示全部" : "分页展示" }}
                </el-button>
            </el-pagination>
        </el-row>
    </div>
</template>
<script>
const FUND_TYPE = {
    "1": "zhaiquan",
    "2": "huobi",
    "3": "hunhe",
    "4": "gupiao"
};
export default {
    name: "AssetsList",
    props: {
        fundInfo: {
            type: Array,
            default: ()=>{
                return [];
            },
            required: true
        },
        allPage: {
            type: String,
            default: ""
        },
        noFundMsg: {
            type: String,
            default: "基金公司没有添加基金产品，请联系基金公司添加！ "
        },
        fundGrowQry: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            fundAll: [],
            curPage: 1,
            url: "", // 当前页面路由命名
            recommendFund: [],
            growArea: {
                "4": "日涨跌幅",
                "9": "近一周涨跌幅",
                "5": "近一月涨跌幅",
                "6": "近三月涨跌幅",
                "7": "近六月涨跌幅",
                "10": "近一年涨跌幅",
                "11": "近两年涨跌幅",
                "12": "近三年涨跌幅",
                "13": "近五年涨跌幅"
            },
            growData: {
                "4": "dayud",
                "9": "week1ud",
                "5": "month1ud",
                "6": "month3ud",
                "7": "month6ud",
                "10": "year1ud",
                "11": "year2ud",
                "12": "year3ud",
                "13": "year5ud"
            },
            isShowAll: false,
            pageSizes: [20, 50, 100],
            pageLayout: "slot, sizes, prev, pager, next",
            pageSize: 20
        };
    },
    watch: {
        fundInfo() {
            this.getNewFund();
        },
        allPage() {
            this.curPage = 1;
        }
    },
    mounted() {
        this.url = this.$route.name;
        this.conf = this.$util.getConfig().const;
        // this.getFundLabel();
    },
    methods: {
        gotoDetail(val){
            // 基金详情跳转链接暂时写死，新增基金详情跳转链接的杂参后再在中台统一配置
            // this.$util.toCompPage("/fund",{secondtype: val.fundcode,etfflag: val.etfflag});
            const openUrl = `http://www.cryuantafund.com/gscp/product/${FUND_TYPE[val.fundtype] || "hunhe"}/${val.fundcode}/index.html`;
            window.open(openUrl,"_blank");

        },
        callbackFn(way, fundcode) {
            const fund = this.fundAll.filter(item => {
                return item.fundcode === fundcode;
            });
            this.$emit("fund-continue", way, fund[0]);
        },
        getNewFund() {
            let _arr = [];
            this.fundInfo.forEach((fund, index) => {
                const _x = Object.assign({}, fund);
                _x.index = index + 1;
                _x.isBuy = this.$util.checkBuy(_x.fundstatus);
                _x.isCurrency = this.$util.checkGeneral(_x);
                _arr.push(_x);
            });
            this.fundAll = _arr;
        },
        dataReset(val) {
            this.$emit("new-fund", val);
        },
        sizeReset(val) {
            this.curPage = 1;
            this.$emit("size-reset", val);
        },
        showAll(evt) {
            let target = evt.target;
            if (target) {
                if (target.nodeName === "SPAN") {
                    target = evt.target.parentNode;
                }
                target.blur();
            }
            this.isShowAll = !this.isShowAll;
            if (this.isShowAll) {
                this.pageLayout = "slot";
            } else {
                this.pageLayout = "slot, sizes, prev, pager, next";
            }
            this.curPage = 1;
            this.$emit("show-all", this.isShowAll);
        },
        // 获取产品标签
        getFundLabel() {
            this.$util.request("trade/fund/tag&").then(res => {
                this.recommendFund = res.data;
                this.getNewFund();
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-fund-list {
    .el-button--small {
        min-width: 80px;
        font-size: 16px;
        padding: 7px 15px;
    }
}
</style>
